import config from "./config";
import React from "react";

export const handleEvent = (
  event: React.ChangeEvent<HTMLInputElement>,
  callback: (illustration: File) => void
) => {
  const { files } = event.target;
  if (files) {
    if (files[0].size > config.imageSizeLimitInBytes) {
      alert(config.imageToHeavyMessage);
      event.target.value = "";
    } else {
      callback(files[0]);
    }
  }
};

export const uploadJPG = (
  toUpload: File,
  successCallback: (file: string | ArrayBuffer | null) => Promise<void>,
  failureCallback: () => void
) => {
  const reader = new FileReader();
  reader.readAsDataURL(toUpload);

  reader.onload = async () => {
    try {
      successCallback(reader.result);
    } catch (error) {
      failureCallback();
      alert(JSON.stringify(error) ?? error);
      console.error(error);
    }
  };
  reader.onerror = function (error) {
    failureCallback();
    alert(error);
    console.error(error);
  };
};
